import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const tiers = [{
  name: 'Sentinel',
  price: '€0',
  period: '/mo',
  description: 'Essential protection for individuals.',
  features: ['Aegis Vault (up to 50 entries)', 'Single-device access', 'Basic breach alerts', 'Community support'],
  cta: 'Deploy Sentinel',
  highlight: false,
  color: 'border-[#1e1e2e]'
}, {
  name: 'Bastion',
  price: '€4.90',
  period: '/mo',
  description: 'Advanced security for power users.',
  features: ['Aegis Vault (unlimited entries)', 'Phantom Relay sharing', 'Cerberus Watch monitoring', 'Cross-device sync (up to 6)', 'Priority encrypted support'],
  cta: 'Fortify with Bastion',
  highlight: true,
  color: 'border-[#00ff88]'
}, {
  name: 'Citadel',
  price: '€11.90',
  period: '/mo',
  description: 'Complete fortress for teams.',
  features: ['Everything in Bastion', 'Obsidian Shield biometric MFA', 'Team vaults (up to 25 members)', 'Admin console & audit logs', 'Dedicated security advisor'],
  cta: 'Command Citadel',
  highlight: false,
  color: 'border-[#00d4ff]'
}];
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-[#0a0a0f] relative" data-id="element-113">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-114">
        <div className="text-center mb-16" data-id="element-115">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-116">
            SELECT YOUR <span className="text-[#00d4ff]" data-id="element-117">CLEARANCE LEVEL</span>
          </h2>
          <p className="text-[#a0a0b0] max-w-2xl mx-auto" data-id="element-118">
            Choose the defense protocol that fits your threat model.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center" data-id="element-119">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className={`relative bg-[#111118] border-2 rounded-xl p-8 flex flex-col h-full ${tier.highlight ? 'border-[#00ff88] shadow-[0_0_30px_rgba(0,255,136,0.15)] scale-105 z-10' : 'border-[#1e1e2e] hover:border-[#00d4ff]/50'} transition-all duration-300`} data-id="element-120">
              {tier.highlight && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#00ff88] text-[#0a0a0f] text-xs font-bold px-4 py-1 rounded-full font-mono uppercase tracking-wider" data-id="element-121">
                  Most Popular
                </div>}

              <div className="mb-8" data-id="element-122">
                <h3 className="text-xl font-bold text-white font-mono mb-2" data-id="element-123">
                  {tier.name}
                </h3>
                <div className="flex items-baseline mb-4" data-id="element-124">
                  <span className="text-4xl font-bold text-white" data-id="element-125">
                    {tier.price}
                  </span>
                  <span className="text-[#a0a0b0] ml-2" data-id="element-126">{tier.period}</span>
                </div>
                <p className="text-[#a0a0b0] text-sm" data-id="element-127">{tier.description}</p>
              </div>

              <ul className="space-y-4 mb-8 flex-1" data-id="element-128">
                {tier.features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-129">
                    <Check className={`w-5 h-5 flex-shrink-0 ${tier.highlight ? 'text-[#00ff88]' : 'text-[#00d4ff]'}`} data-id="element-130" />
                    <span className="text-gray-300 text-sm" data-id="element-131">{feature}</span>
                  </li>)}
              </ul>

              <button className={`w-full py-3 px-6 rounded font-bold font-mono transition-all duration-300 ${tier.highlight ? 'bg-[#00ff88] text-[#0a0a0f] hover:bg-[#00cc6a] hover:shadow-[0_0_20px_rgba(0,255,136,0.4)]' : 'bg-transparent border border-[#00d4ff] text-[#00d4ff] hover:bg-[#00d4ff]/10'}`} data-id="element-132">
                {tier.cta}
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}